/**
 * Session-reminder (MSG-16) button clicks. The magic link carries
 * `fireEvent=true&trigger_type=<slot>&schedule_type=<custom|default>`; the click is saved on
 * landing and tracked once the patient is in (OB1 or the HEP Viewer) - see
 * useRetentionSignal.
 */
const PENDING_PERFORMANCE_TRIGGER_KEY = 'pending_performance_trigger';
// Links sent before slot-based reminders: ?eventType=morningReminder|eveningReminder.
const LEGACY_EVENT_TYPE_KEY = 'pending_event_type';
const LEGACY_TRIGGER_TYPES = { morningReminder: 'morning', eveningReminder: 'last call' };

/** Magic-link landing: remember the click when the link asks for it. */
export const savePendingPerformanceTrigger = searchParams => {
  if (searchParams.get('fireEvent') !== 'true' || !searchParams.get('trigger_type')) {
    return;
  }
  try {
    sessionStorage.setItem(
      PENDING_PERFORMANCE_TRIGGER_KEY,
      JSON.stringify({
        trigger_type: searchParams.get('trigger_type'),
        schedule_type: searchParams.get('schedule_type') ?? undefined,
      })
    );
  } catch (_) {
    // ignore - tracking only
  }
};

/** Read and clear the pending click ({ trigger_type, schedule_type }), or null if none. */
export const takePendingPerformanceTrigger = () => {
  try {
    const saved = sessionStorage.getItem(PENDING_PERFORMANCE_TRIGGER_KEY);
    if (saved) {
      sessionStorage.removeItem(PENDING_PERFORMANCE_TRIGGER_KEY);
      return JSON.parse(saved);
    }
    const legacyEventType = sessionStorage.getItem(LEGACY_EVENT_TYPE_KEY);
    if (LEGACY_TRIGGER_TYPES[legacyEventType]) {
      sessionStorage.removeItem(LEGACY_EVENT_TYPE_KEY);
      return { trigger_type: LEGACY_TRIGGER_TYPES[legacyEventType] };
    }
  } catch (_) {
    // ignore - tracking only
  }
  return null;
};
